module.exports = __webpack_public_path__ + "img/badge-expiredate-red.bc4368e2.svg";